import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconRubRoundForbidden.tsx
const IconRubRoundForbidden = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "M28.003 14.668c0-7.364-5.97-13.335-13.335-13.335-7.364 0-13.335 5.97-13.335 13.335s5.97 13.335 13.335 13.335q1.016 0 1.992-.147A8.555 8.555 0 0 1 27.856 16.66q.146-.976.147-1.992m-16.18-.182V8.52h4.74q1.462 0 2.474.528 1.013.522 1.535 1.418.528.89.528 2 0 1.155-.534 2.032-.534.872-1.547 1.37-1.013.49-2.455.49h-2.469v.934h2.757v1.872h-2.757v1.928h-2.271v-1.928H9.977v-1.872h1.847v-.933H9.977v-1.873z",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ jsx("path", { d: "M16.564 10.41q.766 0 1.264.277.503.27.748.742.252.467.246 1.057.006.6-.246 1.049a1.67 1.67 0 0 1-.76.7q-.51.25-1.302.251h-2.418v-4.075z" }),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "M24.556 18.444a6.111 6.111 0 1 0 0 12.223 6.111 6.111 0 0 0 0-12.223m0 9.778a3.65 3.65 0 0 1-1.581-.357l4.89-4.89a3.667 3.667 0 0 1-3.31 5.247m1.58-6.976-4.89 4.89a3.666 3.666 0 0 1 4.89-4.89",
				clipRule: "evenodd"
			})
		]
	})]
});
var IconRubRoundForbidden_default = forwardRef(IconRubRoundForbidden);
//#endregion
export { IconRubRoundForbidden_default as default };
